module.exports = ".admission-container{\r\n\tpadding: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admissions/components/admission-team/admission-team.component.css
// module id = ./src/app/admissions/components/admission-team/admission-team.component.css
// module chunks = main